// initial state
import * as base from './base.js'
const jobName = '/admin/monitor/job'

const obj = base.setBaseUrl('job', jobName)
const a = Object.assign(obj, )
export default a
